(function (angular, app) {
   "use strict";

   // Slider
   angular.module(app.modules.member.name)
      .directive(app.modules.member.directives.memberpicker, MemberPickerDirective);

   MemberPickerDirective.$inject = ["$timeout", "$q", "ngDialog"
      , app.modules.common.services.functions
      , app.modules.common.services.storage
      , app.modules.common.constants.appsettings
      , app.modules.member.services.search
      , app.modules.invitation.services.invite
      , app.modules.group.services.groups
   ];

   function MemberPickerDirective($timeout, $q, ngDialog
       , ggFunctions
       , ggStorage
       , ggSettings
       , ggMemberSearchSvc
       , ggInvitationSvc
       , ggGroupSvc
       ) {

      var ctrl = this;

      return {
         restrict: "A"
         , templateUrl: "app/member/directives/memberpicker.html"
         , scope: {
            callback: "&"
         }
         , link: function (scope, element, attrs) {

            var isUpdateView = true;

            scope.mp = {
               view: {
                  tabs: {
                     current: 2
                     , types: {
                        search: 1
                        , following: 2
                        , group: 3
                        , groups: 4
                        , add: 5
                        , club : 6
                     }
                     , isActive: function (tab) {
                        return scope.mp.view.tabs.current == tab;
                     }
                     , select: function (tab) {
                        if (!tab) {
                           tab = scope.mp.view.tabs.current;
                        }
                        scope.mp.view.tabs.current = tab;

                        if (tab == 2) {
                           scope.mp.dialog.content.following.fetch();
                        }
                        if (tab == 3) {
                           scope.mp.dialog.content.group.fetch();
                        }
                        if (tab == 4) {
                           scope.mp.dialog.content.groups.fetch();
                        }
                        if (tab == 5) {
                            scope.mp.dialog.content.sendemail.fill();
                        }
                        if (tab == 6) {
                            scope.mp.dialog.content.club.fetch();
                        }
                        // Reset selected
                        scope.mp.dialog.selected = [];
                        scope.mp.dialog.content.search.selected = [];
                        scope.mp.dialog.content.following.selected = [];
                        scope.mp.dialog.content.group.selected = [];


                        scope.mp.view.tabs.current = tab;
                        scope.mp.isError = false;
                        scope.mp.msg = "There were no members found.";
                     }
                  }
                  , isSearch: false
                   , isGroupList: false
                   , isFollowing: false
                   , isClub: false
                   , isAddNew : false
               }
               , window: ggFunctions.fetchWindowSize()
               , buttonText: "Choose Members"
               , buttonClass: "btn-primary"
               , groupId: 0
               , joinGroupId : 0
               , selectedGroupId: 0
               , clubId : 0
               , isLoaded: false
               , isError: false

               , dialog: {
                  alert: ""
                  , isProcessing: false
                  , selected : []
                  , results : []
                  , content: {
                     results: []
                     , search: {
                        form : {
                           name : ""
                        }
                        , isDirty : false
                        , isSearch: false
                        , results: []
                        , selected: []
                        , reset: function () {
                           scope.mp.dialog.content.search.results = [];
                           scope.mp.dialog.content.search.isSearch = false;
                        }
                        , fetch: function (isValid) {
                           scope.mp.dialog.content.search.isDirty = true;
                           if (isValid) {
                              scope.mp.dialog.isProcessing = true;
                              ggMemberSearchSvc.search.fetchMemberSearch(scope.mp.dialog.content.search.form).then(function (data) {
                                 if (data && data.status == "200") {
                                    scope.mp.dialog.content.search.results = data.data.value;
                                 }

                                 if (data.data.value.length == 0){
                                    scope.mp.dialog.alert = "There are no members matching your search criteria.";
                                 }

                              }).finally(function () {
                                 scope.mp.dialog.content.search.isSearch = true;
                                 scope.mp.dialog.isProcessing = false;
                              })
                              ;
                           }
                        }
                        , isSelected: function (id) {
                           var rv = -1;
                           for (var v = 0; v < scope.mp.dialog.content.search.selected.length; v++) {
                              if (scope.mp.dialog.content.search.selected[v].id == id) {
                                 rv = v;
                                 break;
                              }
                           }

                           return rv;
                        }
                        , toggle: function (obj) {
                           var v = scope.mp.dialog.content.search.isSelected(obj.id)
                           if (v > -1) {
                              scope.mp.dialog.content.search.selected.splice(v, 1);
                           } else {
                              scope.mp.dialog.content.search.selected.push(obj);
                           }
                           scope.mp.dialog.selected = scope.mp.dialog.content.search.selected;
                        }
                     }
                     , following: {
                        isSearch : false
                        , results : []
                        , selected : []
                        , fetch: function (isRefresh) {
                           var processData = function (results) {

                              if (results.length > 0) {
                                 // Sort on date
                                 results.sort(function (a, b) {
                                    var d1 = a.name;
                                    var d2 = b.name;
                                    var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                                    return v;
                                 });
                              } else {
                                 scope.mp.dialog.alert = "There are no members that you are following.";
                              }

                              scope.mp.dialog.content.following.results = results
                              scope.mp.dialog.content.following.isSearch = true;
                              return $q.when();
                           }

                           if (scope.mp.dialog.content.following.results.length == 0) {
                              var isCurrent = ggStorage.get(ggStorage.keys.members.my.isCurrent);
                              var storeData = JSON.parse(ggStorage.get(ggStorage.keys.members.my.data)) || [];

                              if (isRefresh || !isCurrent || !storeData || (storeData && storeData.length == 0)) {
                                 scope.mp.dialog.isProcessing = true;
                                 return app.Member.Network.Data.Friends.fetch(true).then(function (data) {
                                    return processData(data);
                                 }).finally(function () {
                                    scope.mp.dialog.isProcessing = false;
                                 });
                              } else {
                                 return processData(storeData);
                              }
                           }
                        }
                        , isSelected: function (id) {
                           var rv = -1;
                           for (var v = 0; v < scope.mp.dialog.content.following.selected.length; v++) {
                              if (scope.mp.dialog.content.following.selected[v].id == id) {
                                 rv = v;
                                 break;
                              }
                           }

                           return rv;
                        }
                        , toggle: function (obj) {
                           var v = scope.mp.dialog.content.following.isSelected(obj.id)
                           if (v > -1) {
                              scope.mp.dialog.content.following.selected.splice(v,1);
                           } else {
                              scope.mp.dialog.content.following.selected.push(obj);
                           }
                           scope.mp.dialog.selected = scope.mp.dialog.content.following.selected;
                        }
                     }
                     , group: {
                        isSearch: false
                        , results: []
                        , selected: []
                        , name : ""
                        , fetch: function (isRefresh) {
                           if (scope.mp.dialog.content.group.results.length == 0){
                               scope.mp.dialog.isProcessing = true;
                               scope.mp.dialog.content.group.isSearch = false;
                              ggMemberSearchSvc.search.fetchMemberSearchByGroup({ groupId: scope.mp.selectedGroupId }).then(function (data) {
                                 if (data && data.status == "200") {
                                    var lst = data.data.value;
                                    var results = [];
                                    for (var x = 0; x < lst.length; x++) {
                                       results.push(lst[x].member)
                                    }
                                    scope.mp.dialog.content.group.results = results;
                                 }
                              }).finally(function () {
                                 scope.mp.dialog.isProcessing = false;
                                 scope.mp.dialog.content.group.isSearch = true;
                              });
                           }

                           

                        }
                        , isSelected: function (id) {
                           var rv = -1;
                           for (var v = 0; v < scope.mp.dialog.content.group.selected.length; v++) {
                              if (scope.mp.dialog.content.group.selected[v].id == id) {
                                 rv = v;
                                 break;
                              }
                           }
                           return rv;
                        }
                        , toggle: function (obj) {
                           var v = scope.mp.dialog.content.group.isSelected(obj.id)
                           if (v > -1) {
                              scope.mp.dialog.content.group.selected.splice(v, 1);
                           } else {
                              scope.mp.dialog.content.group.selected.push(obj);
                           }
                           scope.mp.dialog.selected = scope.mp.dialog.content.group.selected;
                        }
                     }
                     , groups: {
                        results: []
                        , isSearch : false
                        , select: function (group) {
                            scope.mp.selectedGroupId = group.id;
                            scope.mp.dialog.content.group.name = group.name;
                           scope.mp.view.tabs.select(scope.mp.view.tabs.types.group);
                        }
                        , reset: function () {


                            scope.mp.dialog.content.group.isSearch = false;
                            scope.mp.view.tabs.select(scope.mp.view.tabs.types.groups);

                            
                        }
                        , fetch: function () {

                           scope.mp.dialog.isProcessing = true;
                           app.Member.Network.Data.Groups.fetch().then(function (data) {
                              var results = [];

                              // Show groups you orgainze, or groups that you captain
                              for (var g = 0; g < data.length; g++) {
                                  if ((data[g].group.createdBy.id == app.Member.Detail.id) || !data[g].group.isAdminRestricted) {
                                    results.push(data[g]);
                                 }
                              }

                              scope.mp.dialog.content.groups.results = results;
                           }).finally(function () {
                              scope.mp.dialog.isProcessing = false;
                              scope.mp.dialog.content.groups.isSearch = true;

                              // reseet selected group
                              scope.mp.dialog.content.group.results = [];
                              scope.mp.selectedGroupId = 0;
                              scope.mp.dialog.content.group.name = "";

                           });
                        }
                     }
                     , sendemail: {
                        isDirty: false
                        , selected : []
                        , form: {
                           groupId: 0
                           , firstName: ""
                           , lastName: ""
                           , email: ""
                           , handicap: null
                           , gender: app.Member.Detail.gender
                           , address: {
                              postalCode: app.Member.Detail.address.postalCode
                              , line1: null
                               , line2: null
                               , city: null
                               , region: null
                               , country: null
                           }
                        }
                        , fill: function () {
                           scope.mp.dialog.content.sendemail.isDirty = false;
                           scope.mp.dialog.content.sendemail.form.groupId = scope.mp.joinGroupId;
                           scope.mp.dialog.content.sendemail.form.firstName = "";
                           scope.mp.dialog.content.sendemail.form.lastName = "";
                           scope.mp.dialog.content.sendemail.form.email = "";
                           scope.mp.dialog.content.sendemail.form.handicap = null;
                        }
                        , save: function (isValid) {

                           scope.mp.dialog.content.sendemail.isDirty = true;

                           var form = angular.copy(scope.mp.dialog.content.sendemail.form)
                           delete form.groupId;
                           delete form.handicap;

                           var newMemberId = 0;
                           var newMembershipId = 0;
                           var newMemberObj = {};
                           if (isValid) {

                              // Validate User's email
                              var checkUser = function (form) {
                                 return ggMemberSearchSvc.search.fetchMemberSearch(form).then(function (data) {
                                    if (data && data.status == "200") {
                                       if (data.data.value.length > 0) {
                                          isOK = false;
                                          scope.mp.dialog.content.search.results = data.data.value;
                                          scope.mp.dialog.content.search.isSearch = true;
                                          scope.mp.view.tabs.select(scope.mp.view.tabs.types.search);
                                       }
                                    }
                                    return;
                                 }, function (error) {
                                    return;
                                    isOK = false;
                                    scope.mp.isError = true;
                                    scope.mp.dialog.alert = "There was an error checking the email address.";
                                 });
                              }

                              // Insert New User
                              var insertUser = function (form) {
                                 form.userName = form.email;
                                 form.password = ggSettings.defaultPassword;
                                 return app.Member.Network.RegisterAccount(form).then(function (data) {
                                    if (data && data.status == "201") {
                                       newMemberObj = data.data;
                                    } else {
                                       isOK = false;
                                       scope.mp.isError = true;
                                       scope.mp.dialog.alert = "The member account was not created.";
                                    }
                                    return;
                                 }, function (error) {
                                    scope.mp.isError = true;
                                    scope.mp.dialog.alert = "There was an error inserting the new memeber.";
                                    isOK = false;
                                    return;
                                 });
                              }

                              var insertMember = function () {
                                 var form = {
                                    groupId: scope.mp.joinGroupId
                                    , memberId: newMemberObj.id
                                    , effectiveOn: null
                                    , isActive: true
                                 }
                                 return ggGroupSvc.membership.insertGroupMembership(form).then(function (data) {
                                    if (data && data.status == "201") {
                                       newMembershipId = data.data.id;
                                    } else {
                                       scope.mp.isError = true;
                                       scope.mp.dialog.alert = "The member account was created, but they were not added to the group.";
                                    }
                                    return;
                                 }, function (error) {
                                    return $q.resolve();
                                 });
                              }

                              // Insert Handicap
                              var insertHandicap = function (form) {
                                 return ggGroupSvc.membership.autoUpdateGroupHandicap({ groupId: scope.mp.groupId, membershipId: newMembershipId, handicap: scope.mp.dialog.content.sendemail.form.handicap, effectiveOn: null }).then(function (data) {
                                    return;
                                 });
                              }

                              var isOK = true;
                              // Process
                              ggFunctions.toggleProcessing(true);
                               checkUser(form).then(function () {
                                 if (isOK) {
                                    return insertUser(form);
                                 }
                              }).then(function () {
                                 if (isOK) {
                                    return insertMember();
                                 }
                              }).then(function () {
                                 if (isOK) {
                                    return insertHandicap(form);
                                 }
                              }).finally(function () {
                                 ggFunctions.toggleProcessing(false);

                                 if (isOK) {
                                    scope.mp.dialog.content.group.results = [];
                                    scope.mp.dialog.content.sendemail.selected.push(newMemberObj);
                                    ngDialog.closeAll();

                                 }

                              })
                           }
                        }
                        , reset: function () {

                        }
                     }
                     , club: {
                         isSearch: false
                        , results: []
                        , selected: []
                        , fetch: function (isRefresh) {
                            if (scope.mp.dialog.content.club.results.length == 0) {
                                scope.mp.dialog.isProcessing = true;
                                ggMemberSearchSvc.search.fetchMemberSearchByClub({ clubId: scope.mp.clubId }).then(function (data) {
                                    if (data && data.status == "200") {
                                        var lst = data.data.value;
                                        var results = [];
                                        for (var x = 0; x < lst.length; x++) {
                                            if (lst[x].member) {
                                                results.push(lst[x].member)
                                            }
                                        }
                                        scope.mp.dialog.content.club.results = results;
                                    }
                                }).finally(function () {
                                    scope.mp.dialog.isProcessing = false;
                                    scope.mp.dialog.content.club.isSearch = true;
                                });
                            }
                        }
                        , isSelected: function (id) {
                            var rv = -1;
                            for (var v = 0; v < scope.mp.dialog.content.club.selected.length; v++) {
                                if (scope.mp.dialog.content.club.selected[v].id == id) {
                                    rv = v;
                                    break;
                                }
                            }
                            return rv;
                        }
                        , toggle: function (obj) {
                            var v = scope.mp.dialog.content.club.isSelected(obj.id)
                            if (v > -1) {
                                scope.mp.dialog.content.club.selected.splice(v, 1);
                            } else {
                                scope.mp.dialog.content.club.selected.push(obj);
                            }
                            scope.mp.dialog.selected = scope.mp.dialog.content.club.selected;
                        }
                     }
                  }
                  
               }
               , f: {
                  pickMember: function () {
                     ngDialog.closeAll();

                     app.Member.Session.pageTemplates.fetch("app/member/directives/memberpicker-modal.html").then(function (template) {
                        if (isCordova && isCordovaReady) {
                           StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                        }

                        var _memberPicker = ngDialog.open({
                           template: template
                           , plain: true
                           , closeByEscape: true
                           , showClose: false // Manually updating this in dom
                           , className: "slideup picker member"
                           , scope: scope
                        });

                        _memberPicker.closePromise.then(function () {
                           if (isCordova && isCordovaReady) {
                              StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                           }

                           var results = [];
                           if (scope.mp.view.tabs.current == 1) {
                              results = scope.mp.dialog.content.search.selected;
                           }
                           if (scope.mp.view.tabs.current == 2) {
                              results = scope.mp.dialog.content.following.selected;
                           }
                           if (scope.mp.view.tabs.current == 3) {
                              results = scope.mp.dialog.content.group.selected;
                           }
                           if (scope.mp.view.tabs.current == 5) {
                              results = scope.mp.dialog.content.sendemail.selected;
                           }

                           scope.callback()(results);

                        });
                     });



                     scope.mp.view.tabs.select();
                  }
                  , chooseMember: function (member) {
                     if (member) {
                        scope.mp.dialog.selected.push(member);
                     }
                  }
               }
            }

            var loadOptions = function (objStr, isUpdate) {
               if (objStr) {
                  var obj = JSON.parse(objStr);
                  if (obj) {

                     if (obj.buttonText) {
                        scope.mp.buttonText = obj.buttonText;
                     }
                     if (obj.buttonClass) {
                         scope.mp.buttonClass = obj.buttonClass;
                     }

                     // Picker Types
                     if (obj.isAddNew && !scope.mp.view.isAddNew && obj.joinGroupId && obj.joinGroupId > 0) {
                         scope.mp.view.isAddNew = true;
                     }
                     if (obj.isGroupList && !scope.mp.view.isGroupList) {
                         scope.mp.view.isGroupList = true;
                         scope.mp.dialog.content.groups.isSearch = false
                         app.Member.Network.Data.Groups.allmygroups.fetch().then(function (data) {
                             scope.mp.dialog.content.groups.results = data;
                             scope.mp.dialog.content.groups.isSearch = true;
                         });
                     }
                     if (obj.isClub && !scope.mp.view.isClub) {
                         // check if user has a club
                         if (app.Member.Detail.memberships && app.Member.Detail.memberships.length > 0) {
                             var clubMembership = app.Member.Detail.memberships[0];
                             if (clubMembership.club && clubMembership.club.adminData && clubMembership.club.adminData.showClubMembers) {
                                 scope.mp.view.isClub = true;
                                 scope.mp.clubId = clubMembership.club.id;
                             }
                         }
                     }
                     if (obj.isSearch && !scope.mp.view.isSearch) {
                         scope.mp.view.isSearch = true;
                     }
                     if (obj.isFollowing && !scope.mp.view.isFollowing) {
                         scope.mp.view.isFollowing = true;
                         scope.mp.dialog.content.following.isSearch = false;
                         app.Member.Network.Data.Friends.fetch().then(function (data) {
                             scope.mp.dialog.content.following.results = data;
                             scope.mp.dialog.content.following.isSearch = true;
                             

                         });

                     }

                      // We're going to add members to this group
                     if (obj.selectedGroupId && obj.selectedGroupId != scope.mp.selectedGroupId) {
                         scope.mp.selectedGroupId = Number(obj.selectedGroupId);
                         scope.mp.view.tabs.current = scope.mp.view.tabs.types.group;
                         scope.mp.dialog.content.group.isSearch = false
                         scope.mp.dialog.content.group.fetch();
                     }

                      // We're going to add members to this group
                     if (obj.joinGroupId && obj.joinGroupId != scope.mp.joinGroupId) {
                         scope.mp.joinGroupId = Number(obj.joinGroupId);
                     }

                     
                     
                      // clear group members
                     scope.mp.dialog.content.group.results = [];

                  }
               }
            }

            ////////////////////////////////////////
            // Watch for Change in Options
            attrs.$observe('options', function () {
               var optStr = attrs.options;
               if (optStr != "") {
                  loadOptions(optStr, true);
               }
            });
         }
      }
   }
}(angular, app));
